import { render } from "./CleanupDetail.vue?vue&type=template&id=962b0d6e"
import script from "./CleanupDetail.vue?vue&type=script&lang=js"
export * from "./CleanupDetail.vue?vue&type=script&lang=js"

import "./CleanupDetail.vue?vue&type=style&index=0&id=962b0d6e&lang=css"
script.render = render

export default script